/**
 * useContactSubmit — POST /api/v1/contact mutation.
 *
 * The endpoint returns 204 No Content on success, so we hit
 * apiFetch directly instead of apiPost (which always parses JSON).
 */

import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiFetch, HttpError } from '../lib/api'
import type { ContactRequest } from '@warcarp/api-types'

export function useContactSubmit() {
  const client = useQueryClient()
  return useMutation({
    onSuccess: () => client.invalidateQueries({ queryKey: ['support'] }),
    mutationFn: async (input: ContactRequest) => {
      const res = await apiFetch('/api/v1/contact', {
        method: 'POST',
        body: JSON.stringify(input),
      })
      if (!res.ok) {
        const err = (await res.json().catch(() => ({}))) as {
          message?: string
          error?: string
        }
        throw new HttpError(
          res.status,
          err.message ?? err.error ?? `HTTP ${res.status}`,
        )
      }
      // 204 No Content — nothing to parse, nothing to return.
    },
  })
}
